import React from "react";
import { Field } from "formik";
import { YesNoRadio } from "@coverme/forms";

export const YesNoButtons = ({
    name,
    errors,
    touched,
    setFieldValue,
    title,
    getErrors = () => {},
    getValidationState = () => {},
    onFieldChange = () => {},
    isRequired,
}) => {
    if (isRequired == null) {
        isRequired = () => false;
    }

    return (
        <Field
            name={name}
            render={({ field }) => (
                <YesNoRadio
                    selectedYes={field.value}
                    id={name}
                    groupName={name}
                    title={title}
                    errorState={getValidationState(field)}
                    errorMessage={getErrors(field)}
                    required={isRequired(field)}
                    onChange={e => {
                        const value = e.target.value === "yes" ? true : false;
                        if (onFieldChange != null) {
                            onFieldChange(value);
                        }
                        setFieldValue(name, value);
                    }}
                />
            )}
        />
    );
};

export const YesNoButtonsInverted = ({
    name,
    errors,
    touched,
    setFieldValue,
    title,
    getErrors = () => {},
    getValidationState = () => {},
    isRequired,
}) => {
    if (isRequired == null) {
        isRequired = () => false;
    }

    return (
        <Field
            name={name}
            render={({ field }) => (
                <YesNoRadio
                    selectedYes={field.value != null ? !field.value : null}
                    id={name}
                    groupName={name}
                    title={title}
                    errorState={getValidationState(field)}
                    errorMessage={getErrors(field)}
                    required={isRequired(field)}
                    onChange={e => {
                        const value = e.target.value === "yes" ? false : true;
                        setFieldValue(name, value);
                    }}
                />
            )}
        />
    );
};
